// 自动引入当前路径下的所有.vue文件，并注册为Layer组件
import Vue from 'vue';

const registerLayers = () => {
  const layerModules = require.context('./', true, /^[^_].*\.vue$/);

  layerModules.keys().forEach((key) => {
    const layerModule = layerModules(key);

    Vue.component(layerModule.default.name, layerModule.default);
  });
};

export default registerLayers;
